import $ from 'jquery';
import AbortController from 'abort-controller';

import autofill from './autofill';
import createYearSlider from './year-slider';
import options from './options';
import createMap from './map';
import initFavListButtons from './initFavListButtons';
import delay from '../util/delay';

// Define "globals" that can be mutated to contain the AbortController
let controller, signal;

export default function artworkSearch() {
  const elements = Array.from(
    document.querySelectorAll('.artist-artwork-search')
  );

  elements.forEach(element => {
    const form = element.querySelector('form');
    const mapContainer = element.querySelector(
      '.artist-artwork-search__results__map'
    );
    // const searchInput = form.querySelector('input[name="query"]');
    const optionsInput = form.querySelector('input[name="options"]');

    const moreButton = element.querySelector(
      '.artist-artwork-search__results__more'
    );
    const [
      buttonCurrentlyShown,
      buttonResultsCount,
    ] = moreButton.querySelectorAll('span');

    const resultsContainer = element.querySelector(
      '.artist-artwork-search__results'
    );
    const [titleQuery, titleResultsCount] = resultsContainer.querySelectorAll(
      'h2 span'
    );
    const resultsList = resultsContainer.querySelector(
      '.artist-artwork-search__results__list'
    );
    const resultsHeader = resultsContainer.querySelector(
      '.artist-artwork-search__results__header h2'
    );
    const modeButtons = Array.from(
      element.querySelectorAll(
        '.artist-artwork-search__results__header__viewtoggles button'
      )
    );
    let mode = element.getAttribute('data-mode'); // list or map

    const searchOptions = options(optionsInput);
    const { updateMap, initializeMap } = createMap(mapContainer);

    initializeMap();

    const updateTitle = (query, count) => {
      if (query) {
        titleQuery.textContent = `"${query}"`;
        resultsHeader.classList.remove('hidden');
      } else {
        titleQuery.textContent = '';
        resultsHeader.classList.add('hidden');
      }

      titleResultsCount.textContent = `(${count})`;
    };

    const updateLoadMore = (currentlyShown, totalPosts) => {
      buttonResultsCount.textContent = totalPosts;
      buttonCurrentlyShown.textContent = currentlyShown;

      if (totalPosts > currentlyShown) {
        moreButton.classList.remove('hidden');
      } else {
        moreButton.classList.add('hidden');
      }
    };

    const update = (nukeCurrent = true) => {
      // Commented out because switching between views results in a broken UX
      // if there's no search query.
      // if (mode === 'list' && searchInput.value.trim().length < 2) {
      // return;
      // }

      // If the query changed, all the results are invalid. Get rid of them.
      if (nukeCurrent) {
        resultsList.innerHTML = ''; // Dirty, but there's no real benefit in a while loop...
        searchOptions.set('previous_results', []);
      }

      // If these are set, there's a request in progress.
      // Get rid of it.
      if (controller && controller.abort) {
        controller.abort();
      }

      // Add the ability to abort (again)
      controller = new AbortController();
      signal = controller.signal;

      // Build a querystring. Might as well use jQuery since it's there.
      const target =
        form.getAttribute(`data-mode-${mode}`) + '?' + $(form).serialize();

      fetch(target, {
        method: 'GET',
        signal,
      })
        .then(r => r.json())
        .then(data => {
          const { query, count, results } = data;

          // Show the results div. It stays visible, even if the user nulls the query.
          resultsContainer.classList.add('visible');
          updateTitle(query, count);

          switch (mode) {
            case 'list': {
              const { previous_results } = data;
              // Keep track of the IDs, send previous IDs to server so they aren't included again
              searchOptions.set('previous_results', previous_results);

              // Append the HTML from the response.
              resultsList.insertAdjacentHTML('beforeend', results);

              const resultElements = resultsContainer.querySelectorAll(
                '.artist-artwork-search__results__list > *'
              );
              updateLoadMore(resultElements.length, count);
              break;
            }

            case 'map': {
              updateMap(results);
              break;
            }
            // no default
          }

          // Initialize favourites lists buttons
          initFavListButtons();

          // Request completed succesfully, prevent new reqs from aborting something that's
          // already done.
          controller = null;
        })
        .catch(e => {
          if (e.name === 'AbortError') {
            // thisisfine.jpg
          } else {
            // THISISNOTFINE.jpg
            console.error(e);

            // Better tell the user that something is wrong.
            resultsContainer.classList.add('visible');
            titleQuery.innerHTML = `
            <br><br>
            Error: ${e.message}`;
            titleResultsCount.textContent = '';

            switch (mode) {
              case 'list': {
                updateLoadMore(0, -1);

                break;
              }

              case 'map': {
                updateMap([]);
                break;
              }

              // no default
            }
          }

          // Let the user try again with a new request.
          controller = null;
        });
    };

    // Turn it interactive
    autofill(form, update);
    createYearSlider(
      element.querySelector('.artist-artwork-search__creation-year .range'),
      update
    );
    // listen input search text with delay
    form.addEventListener(
      'keyup',
      delay(e => {
        update();
      }, 500)
    );

    // listen form select changes
    form.querySelectorAll('select').forEach(item => {
      item.addEventListener('change', () => update());
    });

    form.addEventListener('submit', e => e.preventDefault() && update());
    moreButton.addEventListener('click', () => update(false));
    modeButtons.forEach(button =>
      button.addEventListener('click', () => {
        modeButtons.forEach(x => x.classList.remove('active'));
        button.classList.add('active');

        mode = button.getAttribute('data-newmode');
        element.setAttribute('data-mode', mode);

        update();
      })
    );

    // fetch on start
    update();
  });
}
